import { LanguageContext } from '@/contexts';
import { ColumnsSettingContext, IColumnSettingsPayload } from '@/utils';
import { Loading } from '@amili-v3/amili-v3-design';
import { ConfigProvider } from 'antd';
import { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../form/zod.config';
import Router from './Router';
import './styles.scss';
import { defaultTheme } from './theme';

const App = () => {
  const [columnsList, setColumnsList] = useState<IColumnSettingsPayload[]>([]);
  const { t } = useTranslation();

  const { isLoading: isLoadingLanguage } = useContext(LanguageContext);

  const locale = useMemo(() => {
    return { locale: '', Empty: { description: t('design.noData') } };
  }, [t]);

  return (
    <ConfigProvider locale={locale} theme={defaultTheme}>
      <ColumnsSettingContext.Provider
        value={{ columns: columnsList, setColumnsSetting: setColumnsList }}
      >
        <div className="app">{isLoadingLanguage ? <Loading /> : <Router />}</div>
      </ColumnsSettingContext.Provider>
    </ConfigProvider>
  );
};

export default App;
